const getIsLastCommentNotTheirOwn = (
  commentThreadLength,
  annotation,
  userId,
  latestCommentInThread,
) => {
  if (commentThreadLength === 0) {
    return annotation.user.id !== userId;
  } else {
    return latestCommentInThread?.user.id !== userId;
  }
};

export default getIsLastCommentNotTheirOwn;
